<template>
  <div class="content">
    <card>
      <div class="row">
        <ArtistSelect
          class="col-md-4"
          @memberChangeEvent="getArtistInfo"
          :show-all-units="true"
          :show-members="false"
          :is-filter="true"
          :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
        />
      </div>
    </card>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 80px">이미지</th>
              <th>유닛</th>
              <th>ID / 타입</th>
              <th>제목</th>
              <th>시작</th>
              <th>종료</th>
              <th style="width: 180px">액션</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in threads" :key="item.id">
              <td>
                <img
                  v-if="item.imageFileUrl"
                  class="cover-img"
                  :src="item.imageFileUrl"
                  :alt="item.title"
                  style="width: 64px; height: 64px; object-fit: cover; border-radius: 4px"
                />
                <img v-else src="@/assets/img/blip-logo.png" style="width: 64px; height: 64px; object-fit: contain" />
              </td>
              <td>{{ item.unitName }}</td>
              <td>{{ item.id }}: {{ item.type }}</td>
              <td>
                <div v-if="item.type === 'ALBUM'">
                  <div>{{ item.albumName }}</div>
                  <small>({{ item.targetTime }})</small>
                </div>
                <div v-else>
                  {{ item.artistName }}
                </div>
              </td>
              <td>{{ item.startTime }}</td>
              <td>{{ item.endTime }}</td>
              <td>
                <base-button @click="goThreadForm(item.id)" type="default">상세</base-button>
                <base-button @click="sendThreadNotification(item)" type="default">알림전송</base-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
      </div>
    </div>
  </div>
</template>
<script>
import { BaseButton, BasePagination, Card } from "@/components/index";
import { formatDateTime } from "@/util/DateUtils";
import ArtistSelect from "@/pages/Components/ArtistSelect";
import { Alert } from "@/util/Alert";

export default {
  components: {
    BasePagination,
    Card,
    BaseButton,
    ArtistSelect,
  },
  data() {
    return {
      isVisible: 1,
      currentPage: 1,
      totalPages: 1,
      threads: [],
      options: [
        { label: "표시", value: 1 },
        { label: "숨김", value: 0 },
      ],
    };
  },
  methods: {
    async getThreads() {
      return this.$axios.get(`/thread`, { params: { unitId: this.unitId } }).then((res) => {
        this.totalPages = res.data.data.page;
        this.threads = res.data.data.data.map((thread) => {
          const imgId = thread.type === "ALBUM" ? thread.albumImageUrl : thread.imageFileId || thread.artistImageFileId || null;
          thread.imageFileUrl = imgId ? (thread.type === "ALBUM" ? imgId : window.Endpoints.imageServerUrl + imgId) : null;

          thread.startTime = formatDateTime(thread.startTime);
          thread.endTime = formatDateTime(thread.endTime);
          thread.targetTime = formatDateTime(thread.targetTime);

          return thread;
        });
      });
    },
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      await this.getThreads();
    },

    async sendThreadNotification(thread) {
      Toast.error("미구현");
      return;
      if (await Alert.dangerousConfirmCancel("알림 전송 확인", `알림을 전송 하시겠습니까?`)) {
        return this.$axios.post(`/thread/${thread.id}/notification`).then((res) => {
          Toast.success("알림이 전송되었습니다");
        });
      }
    },

    goThreadForm(threadId) {
      if (threadId) {
        this.$router.push(`/thread/threadForm?unitId=${this.unitId}&threadId=${threadId}`);
      } else {
        this.$router.push(`/thread/threadForm?unitId=${this.unitId}`);
      }
    },
  },
};
</script>
<style></style>
